// 这是一个用来配置pageview事件的配置表
// 只能配置router定义过的path，router.tsx
export const Event = {
  Web3PageView: 'Web3PageView',
  Web3UserClick: 'Web3UserClick',
};

export const Page = {
  AirdropArcadeHome: 'AirdropArcade_Homepage',
  AirdropArcadeDetail: 'AirdropArcade_DetailPage',
  AirdropArcadeInviteToEarnH5: 'AirdropArcadeInviteToEarnH5',
  AirdropArcadeInviteToEarn: 'AirdropArcadeInviteToEarn',
  InviteToEarnRanking: 'InviteToEarnRanking',
  AirdropTonnect: 'AirdropTonnect',
};

export const pageViewConfigList = [
  {
    page_url: '',
    page_name: Page.AirdropArcadeHome,
  },
  {
    page_url: 'activity',
    page_name: Page.AirdropArcadeDetail,
    search: 'activityTag=3',
  },
];
